import { render, staticRenderFns } from "./UserRolesSelect.vue?vue&type=template&id=d0d15160"
import script from "./UserRolesSelect.vue?vue&type=script&lang=js"
export * from "./UserRolesSelect.vue?vue&type=script&lang=js"
import style0 from "./UserRolesSelect.vue?vue&type=style&index=0&id=d0d15160&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports